module.exports = __webpack_public_path__ + "img/es-back.c920867b.png";